import { Box, Select, MenuItem, Typography, Pagination } from '@mui/material';
import { abyssColors, primary, white } from '@/theme/colors';
import { ExpandMore } from '@mui/icons-material';

type Props = {
  count: number;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: { label: string; value: number }[];
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (updatedRowsPerPage: number) => void;
};

export const TablePagination = ({
  count,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange,
}: Props) => {
  const totalPages = rowsPerPage === -1 ? 1 : Math.ceil(count / rowsPerPage);
  const handleChangePage = (newPage: number) => onPageChange(newPage - 1);
  const handleRowsPerPageChange = (newRowsPerPage: string) => {
    onRowsPerPageChange(Number.parseInt(newRowsPerPage, 10));
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="end" my={2}>
      <Box display="flex" alignItems="center">
        <Typography sx={{ marginRight: '8px', color: primary.darkBlue, fontSize: '12px' }}>
          Rows per page:
        </Typography>
        <Select
          value={rowsPerPage}
          onChange={(event) => handleRowsPerPageChange(event.target.value as string)}
          IconComponent={ExpandMore}
          variant="outlined"
          size="small"
          sx={{
            width: '69px',
            height: '26px',
            fontSize: '12px',
            background: 'white',
            '& .MuiSelect-icon': { color: abyssColors.primary[500] },
            '.MuiOutlinedInput-notchedOutline': {
              borderRadius: '4px',
              borderColor: abyssColors.primary[300],
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: abyssColors.primary[300],
            },
          }}
        >
          {rowsPerPageOptions.map(({ label, value }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Pagination
        count={totalPages}
        shape="rounded"
        size="small"
        page={page + 1}
        onChange={(_, updatedPage) => handleChangePage(updatedPage)}
        sx={{
          '& .MuiPaginationItem-root': { color: primary.darkBlue },
          '& .Mui-selected': {
            color: white,
            backgroundColor: primary.light,
            ':hover': { backgroundColor: primary.light },
          },
        }}
      />
    </Box>
  );
};
